<template>
    <v-menu color="background">
        <template #activator="{ props }">
            <v-btn
                :aria-label="t('labels.loggedInUserIcon')"
                :icon="mdiAccount"
                size="24"
                color="slate-grey"
                elevation="0"
                v-bind="props"
                variant="flat"
                class="small-icon-button"
            ></v-btn>
        </template>
        <v-list class="user-menu py-0" color="background" data-cy="user-menu">
            <v-list-item data-cy="username" class="user-menu-item">
                <template #prepend>
                    <v-avatar size="25" class="mx-2 user-picture">
                        <v-icon :icon="mdiAccountBoxOutline" />
                    </v-avatar>
                </template>
                <v-list-item-title class="mr-3 left-text-align">{{
                    userName
                }}</v-list-item-title>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item
                data-cy="logout-button"
                class="user-menu-item"
                @click="handleLogout()"
            >
                <template #prepend>
                    <v-avatar size="25" class="mx-2 user-picture">
                        <v-icon :icon="mdiLogoutVariant" />
                    </v-avatar>
                </template>
                <v-list-item-title class="mr-2 left-text-align"
                    >Logout</v-list-item-title
                >
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script setup lang="ts">
import { handleLogout } from "@/helpers/session";
import { useI18n } from "vue-i18n";
import { mdiAccountBoxOutline, mdiLogoutVariant, mdiAccount } from "@mdi/js";

defineProps<{
    userPicture?: string;
    userName?: string;
}>();

const { t } = useI18n();
</script>
